import React, { ReactInstance, useEffect, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { Patient } from '../../redux/types';

import { PrescriptionAddField } from './PrescriptionAddField';
import { PrescriptionPrint } from './PrescriptionPrint';
import Axios from '../../utils/axios';
import { setPatientFromAxios } from '../../redux/reducers/patient';
import { Link } from 'react-router-dom';
import { MedicineKind } from '../Medicines';

export type Drug = {
	drugName: string;
	drugDose?: number | null;
	drugFrequency: string;
	drugDuration: string;
	content?: string[];
	kind?: MedicineKind;
};

export type PrescriptionPrintProps = {
	prescription: Prescription;
	patient: Patient;
	setPrescription: (prescription: Prescription) => void;
};

export type PrescriptionEditorProps = {
	prescription: Prescription;
	setPrescription: (prescription: Prescription) => void;
};

type Prescription = {
	medicines: Drug[];
};

const PrintPrescription: React.FunctionComponent = () => {
	const { id, recipeId } = useParams<{ id: string; recipeId?: string }>();

	const patient = useSelector<{ patient: Patient }>((state) => state.patient) as Patient;

	const dispatch = useDispatch();
	useEffect(() => {
		async function getData() {
			const res = await Axios.get(`/patient/${id}`);
			const userData = res.data;
			dispatch(setPatientFromAxios(userData));
		}
		async function getRecipe() {
			const res = await Axios.get(`/recipe/${recipeId}`);
			const recipeData = res.data;

			setPrescription(recipeData);
		}
		getData();
		if (recipeId) {
			getRecipe();
		}
	}, [id, dispatch]);

	const [prescription, setPrescription] = useState<Prescription>({
		medicines: []
	});
	const componentRef = useRef();
	const handlePrint = useReactToPrint({
		content: () => componentRef.current as unknown as ReactInstance
	});

	const saveRecipe = async () => {
		// check if prescription.medcines is empty
		if (prescription.medicines.length === 0) {
			alert('حداقل یک دارو وارد کنید.');
			return;
		}
		const data = {
			medicines: prescription.medicines,
			patient_id: id
		};

		const res = await Axios.post(`/recipe/create/`, data);
		const recipe_id = res.data.id;
		window.location.href = `/patient/${id}/recipe/${recipe_id}`;
	};

	const updateRecipe = async () => {
		// check if prescription.medcines is empty
		if (prescription.medicines.length === 0) {
			alert('حداقل یک دارو وارد کنید.');
			return;
		}
		const data = {
			medicines: prescription.medicines
		};
		await Axios.put(`/recipe/${recipeId}`, data);
		alert('بروزرسانی با موفقیت انجام شد.');
	};

	const deleteRecipe = async () => {
		if (confirm('آیا از حذف این نسخه اطمینان دارید؟')) {
			await Axios.delete(`/recipe/${recipeId}`);
			window.location.href = `/patient/${id}`;
		}
	};

	return (
		<div className="m-5 text-lg">
			{/* create a form to add or remove prescriptions */}
			<PrescriptionAddField prescription={prescription} setPrescription={setPrescription} />
			<div className="m-3 bg-white border-2 border-separate shadow-md border-coolGray-600 ">
				<PrescriptionPrint
					prescription={prescription}
					patient={patient}
					ref={componentRef}
					setPrescription={setPrescription}
				/>
			</div>
			<div className="flex flex-row-reverse">
				<button
					className="p-2 m-3 text-sm text-white rounded-lg shadow-lg bg-blue-320 hover:bg-blue-900"
					onClick={handlePrint}
				>
					چاپ نسخه
				</button>

				{recipeId ? (
					<>
						<button
							className="p-2 m-3 text-sm text-white bg-red-500 rounded-lg shadow-lg hover:bg-red-400"
							onClick={deleteRecipe}
						>
							حذف نسخه
						</button>
						<button
							className="p-2 m-3 text-sm text-white bg-green-500 rounded-lg shadow-lg hover:bg-green-400"
							onClick={updateRecipe}
						>
							بروزرسانی نسخه
						</button>
					</>
				) : (
					<button
						className="p-2 m-3 text-sm text-white rounded-lg shadow-lg bg-blue-320 hover:bg-blue-900"
						onClick={saveRecipe}
					>
						ذخیره
					</button>
				)}
				{/* <div className="bg-black fle" /> */}

				<Link
					className="p-2 m-3 text-sm text-white rounded-lg shadow-lg bg-emerald-800 hover:bg-emerald-700"
					to={`/patient/${id}`}
				>
					بازگشت به صفحه بیمار
				</Link>
			</div>
		</div>
	);
};

export default PrintPrescription;
